<template>
  <div :style="scaleStyle" ref="previewMain" :class="{ 'is-sample': isSample, 'is-preview': !isSample }">

    <div class="doc-paper preview rirekisho" :id="idPrefix + 'preview-page-01'" style="font-size: 22px;">
      <div>
        <div class="rirekisho-box1" style="width: auto; margin-bottom: 100px;" :style="formatData.selFontStyle">
          <div class="rirekisho-header" style="display: block; margin-bottom: 100px;">
            <div class="title" style="text-align: center; font-size: 35px;">{{ formatData.documentTitle }}</div>
            <div class="date" :data-highlight="highlightMessage" @click="goCardTo('create-date')"
              :class="highLightClass('create-date')" style="font-size: 22px; text-align: right;"><span
                v-html="formatedCreateDate"></span>
            </div>
          </div>
          <div class="rirekisho-profile" style="border: none;" :data-highlight="highlightMessage"
            @click="goCardTo('company')" :class="highLightClass('company')" :style="formatData.selFontStyle">
            <div class="section flex">
              <!--<div class="label">宛先部署</div>-->
              <div class="input border-bottom"
                style="border-bottom: 1px solid #000; padding: 10px; font-size: 22px;"
                :style="formatData.selFontStyle">{{ formatData.company_name }}</div>
            </div>
            <div class="section flex">
              <!--<div class="label">宛先部署</div>-->
              <div class="input border-bottom"
                style="border-bottom: 1px solid #000; width: 250px; padding: 10px; font-size: 22px;"
                :style="formatData.selFontStyle">{{ formatData.staff_department_name }}</div>
            </div>
            <div class="name flex" style="border: none; height: auto;" :style="formatData.selFontStyle">
              <!--<div class="label">宛先</div>-->
              <div class="input border-bottom"
                style="border-bottom: 1px solid #000; width: 250px; padding: 10px; font-size: 22px;"
                :style="formatData.selFontStyle">{{ formatData.staff_name }}<span>
                  殿</span>
              </div>
            </div>
          </div>
          <div data-highlight="クリックで編集" class="rirekisho-profile" style="border: none;"
            @click="goCardTo('taishokuprofile')">
            <div class="section" :style="formatData.selFontStyle">
              <!--<div class="label">自分の部署</div>-->
              <div class="input border-bottom right"
                style="border-bottom: 1px solid #000; width: 300px; padding: 10px; margin: 0 0 0 auto;">
                <span>所属：　</span>{{ basicData.department_name }}
              </div>
            </div>
            <div class="name" style="border: none; height: auto;" :style="formatData.selFontStyle">
              <!--<div class="label">自分</div>-->
              <div class="input border-bottom right"
                style="border-bottom: 1px solid #000; width: 300px; padding: 10px; margin: 0 0 0 auto; font-size: 22px;">
                <span>氏名：　</span>{{ basicData.lastName }}&emsp;{{ basicData.firstName }}
              </div>
            </div>
            <div class="name" style="border: none; height: auto;" :style="formatData.selFontStyle">
              <!--<div class="label">自分</div>-->
              <div class="input border-bottom right"
                style="border-bottom: 1px solid #000; width: 300px; padding: 10px; margin: 0 0 0 auto; font-size: 22px;">
                <span>退職日：　</span><span v-html="formatedTaishokuDate"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rirekisho-box2" style="border: none;" @click="goCardTo('taishokureason')">
        <div class="text-right pillow" style="margin-bottom: 50px;" :style="formatData.selFontStyle">私儀</div>
        <div class="main-text" style="margin-bottom: 50px;" :style="formatData.selFontStyle" v-if="false">
          　このたび、<span>{{ formatData.taishokureason }}</span>誠に勝手ながら<span
            v-html="formatedTaishokuDate"></span>をもって退職いたします。
        </div>
        <div class="main-text" style="margin-bottom: 50px;" :style="formatData.selFontStyle">
          {{ formatData.taishokureason }}
        </div>
        <div class="text-right" :style="formatData.selFontStyle">以上</div>
      </div>
    </div>
  </div>
</template>

<script>
import TaishokutodokePreviewMixin from '@/mixins/taishokutodoke-preview-mixin'
export default {
  name: 'taishokutodokePreview',
  mixins: [TaishokutodokePreviewMixin],
  data: function () {
    return {
      textareaMaxHeights: {
        introSummary: 90,
        resumeSummary: 90,
        entrySummary: 210
      }
    }
  },
  computed: {
  },
  methods: {
    checkValid: function () {
      this.adjustFontSize('introSummary')
      this.adjustFontSize('resumeSummary')
      this.adjustFontSize('entrySummary')
    }
  }
}
</script>
